import { createFileRoute } from '@tanstack/react-router';
import { ProjectDashboard } from '@/features/projects/ProjectDashboard';

export const Route = createFileRoute('/_app/projects/$projectId/dashboard')({
  component: ProjectDashboard,
});
